import React from "react";
import classNames from "classnames";

export default ({ text, img, solid }) => (
  <div className={classNames("avatar-container", { solid })}>
    {img ? <img src={img} alt="" /> : text}
  </div>
);
